import styled from 'styled-components';
import { Button, ModalBody, ModalContent, ModalFooter, Typography } from '@web-chat-core/ui-kit';

export const CallNotStartedModalBody = styled(ModalBody)`
    box-sizing: border-box;
    width: 418px;
    padding: 36px;
    background: ${(props) => props.theme.root.colors.background.sheetOrModal};
`;

export const CallNotStartedModalContent = styled(ModalContent)`
    margin-bottom: 32px;
    padding: 0;
`;

export const CallNotStartedMessage = styled(Typography)`
    font-size: 20px;
    line-height: 30px;
    letter-spacing: 0.15px;
    color: ${(props) => props.theme.root.colors.basicColors['90%']};
`;

export const CallNotStartedModalFooter = styled(ModalFooter)`
    padding: 0;
    justify-content: flex-end;
`;

export const CallNotStartedButton = styled(Button)`
    min-width: 120px;
`;
